import React from 'react';
import { Collapse } from 'antd';
import styles from './index.module.scss';

interface InformationProps {
  current?: number;
  countryId?: number;
}
const { Panel } = Collapse;

export default function Information({
  current,
  countryId,
}: InformationProps): React.ReactElement {
  let content;

  if (current === 0) {
    content = (
      <>
        <span>
          We request this information to provide you with the most reliable and
          accurate data.
        </span>
        <ul>
          <li>
            <strong>Country:</strong> We welcome users from all countries!
            However, certain features and surveys focus exclusively on American
            tipping culture, these are only available to our US-based users.
          </li>
          <li>
            <strong>Birth year:</strong> This information helps to provide our
            users with insights and information on generational tipping trends.
            Our minimum user age is 16.
          </li>
          <li>
            <strong>Zip Code:</strong> This information helps to provide our
            users with insights and information on regional tipping trends.
          </li>
        </ul>
        <span>
          Your privacy matters to us—your data is safe and only used to enhance
          your experience!
        </span>
        <br />
        <br />
        <span>We will not sell your personal information.</span>
      </>
    );
  } else if (current === 1 && countryId === 233) {
    content = (
      <span>
        This information helps to provide our users with relevant insights and
        information on industry based tipping trends and expectations.
      </span>
    );
  } else if (
    (current === 1 && countryId !== 233) ||
    (current === 3 && countryId === 233)
  ) {
    content = (
      <span>
        This information contributes to comparisons of worker expectations and
        customer averages for your occupation. This data and further insights
        can be viewed under “Tipping Categories.”
      </span>
    );
  }

  return (
    <Collapse
      defaultActiveKey={['1']}
      bordered={false}
      style={{ backgroundColor: '#E9EBF0', borderRadius: 24, padding: 32 }}
      expandIconPosition="end"
    >
      <Panel
        header={<h4>Why Do We Ask for This Information?</h4>}
        key="1"
        className={styles.info}
      >
        {content}
      </Panel>
    </Collapse>
  );
}
